import React, { createContext, useContext, useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";
const AuthContext = createContext({});

function loadUser() {
  try {
    return JSON.parse(localStorage.getItem("sl_user") || "null");
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(loadUser);

  const save = (user) => {
    localStorage.setItem("sl_user", JSON.stringify(user));
    setCurrentUser(user);
  };

  const register = async (email, password, name) => {
    try {
      const res = await fetch(`${API}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, name }),
      });
      const data = await res.json();
      if (!res.ok) return { ok: false, error: data.error };
      save(data.user);
      return { ok: true };
    } catch {
      return {
        ok: false,
        error: "Connection failed. Please check your internet.",
      };
    }
  };

  const login = async (email, password) => {
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) return { ok: false, error: data.error };
      save(data.user);
      return { ok: true };
    } catch {
      return {
        ok: false,
        error: "Connection failed. Please check your internet.",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("sl_user");
    localStorage.removeItem("sl_started");
    setCurrentUser(null);
  };

  const unlockWithCode = async (code) => {
    if (!currentUser)
      return { ok: false, error: "You must be logged in to activate a code." };
    try {
      const res = await fetch(`${API}/api/code/activate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, email: currentUser.email }),
      });
      const data = await res.json();
      if (!res.ok) return { ok: false, error: data.error };
      const updated = {
        ...currentUser,
        access_code: code.trim().toUpperCase(),
      };
      save(updated);
      return { ok: true };
    } catch {
      return { ok: false, error: "Connection failed. Please try again." };
    }
  };

  const hasFullAccess = !!currentUser?.access_code;

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        register,
        login,
        logout,
        unlockWithCode,
        hasFullAccess,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
